import React from "react";
import { RouteComponentProps } from "@reach/router"

import { styled } from '@material-ui/core';
import AppPage from "../../components/AppFrame/AppPage";
import { useEffect } from "react";
import { actions } from '../../services/chatMessages';
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store";
import ChatDetails from "./ChatDetails";
import MessageList from "./MessagesList";

const Root = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
});




interface Props extends RouteComponentProps {
  chatId?: string;
}

const Chat: React.FC<Props> = ({ chatId }) => {

  const state = useSelector((state: RootState) => state.chatMessages);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!chatId) {
      return;
    }

    dispatch(actions.loadChat(chatId));
    dispatch(actions.loadMessages(chatId));

    return () => {
      dispatch(actions.resetChat());
      dispatch(actions.resetMessages());
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <AppPage title="Chat" loading={state.chatLoading || state.messagesLoading}>
      <Root>
        {
          !state.chat ? null : <ChatDetails chat={state.chat} />
        }
        <MessageList messages={state.messages} />
      </Root>
    </AppPage>
  );
};

export default Chat;